import { TemplateRef } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { ColumnInputType } from './column-input-type';
import { ColumnOutputType } from './column-output-type';
import { TableFilterType } from './filtering/table-filter-type';

export class TableColumn {
  public formatterPipe: any;
  public formatterPipeArgs: any[];
  public linkClickEvent: any;
  public linkDisabledField: string;
  public linkDisabledPipe: any;
  public linkDisabledPipeArgs: any[];
  public dropdownChangedEvent: any;
  public dropdownFocusEvent: any;
  public outputType: ColumnOutputType = ColumnOutputType.Text;
  public modelChangeEvent: any = null;
  public additionalInfo: string = null;
  public widthPx: number;
  public minWidthPx: number;
  public hideFilter: boolean = false;
  public hideColumnData: boolean = false;
  public hideColumnDataByRowValue: string = null;
  public filterType: TableFilterType = TableFilterType.String;
  public sortTransformation: any = (data: any) => data;
  public columnKey: string;

  public customOutputTemplateRef: TemplateRef<any>;
  public customInputTemplateRef: TemplateRef<any>;

  constructor(
    public header: string,
    public valueField: string,
    public labelField: string = '', // for use with dropdown input
    public sortable: boolean = true,
    public editable: boolean = false,
    public inputType: ColumnInputType = ColumnInputType.Text,
    public options: SelectItem[] = [],
  ) {}
}
